/* MUI */
import { Box } from '@mui/material';

/* Hooks */
import { useFetchApplicationAccounts } from 'hooks/dataAccess/User/userApplicationAccounts';

/*  React  */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

/* api params */
const params = {
    size: -1,
    uniqueAccountsOnly: true
};

export const AccountPicker = (props) => {
    const makePayload = ({ accounts, setLoaded, setObjectPayload }) => {
        setLoaded(false);
        const objectPayload = accounts.map((username) => ({
            componentToDisplay: <Box width="100%">{username}</Box>,
            id: username,
            username
        }));

        setObjectPayload(objectPayload);
        setLoaded(true);
    };

    const [loaded, setLoaded] = useState(false);
    const [objectPayload, setObjectPayload] = useState([]);

    const { clientId } = useParams();

    const { accounts } = useFetchApplicationAccounts({
        clientId,
        params
    });

    useEffect(() => {
        makePayload({ accounts, setLoaded, setObjectPayload });
    }, [accounts]);

    return (
        loaded && (
            <ObjectPicker
                {...props}
                objectPayload={objectPayload}
                objectNameField="username"
                objectNameFieldVisualOnly="componentToDisplay"
                visualOnlyDefault={undefined}
            />
        )
    );
};
